import axios from "axios";

const API_URLS = {
  dev: "http://159.195.44.197:8000",
  prod: "https://telviora.com/api",
};

const getApiUrl = () => {
  if (process.env.NODE_ENV !== "production") return API_URLS.dev;
  // what if it IS production (aka build)? We need to check if this isn't a DEV build!
  if (process.env.REACT_APP_DEV_BUILD === "true") return API_URLS.dev;
  return API_URLS.prod;
};

export const apiClient = axios.create({
  baseURL: getApiUrl(),
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const handleError = (error) => {
  const status = error.response?.status;
  const url = error.config?.url || "";

  if (status === 401 && !url.includes("/auth/login")) {
    localStorage.removeItem("token");
    window.location.href = "/sign-in";
    return Promise.reject(error);
  }

  if (!error.response?.status && error.request) {
    error.status = error.request.status;
    error.response = {
      status: error.request.status,
      data: error.response?.data || {},
    };
  }

  return Promise.reject(error);
};

apiClient.interceptors.response.use((response) => response, handleError);

export default apiClient;
